import { render, staticRenderFns } from "./alertTracker.vue?vue&type=template&id=654184fd&scoped=true&"
import script from "./alertTracker.vue?vue&type=script&lang=js&"
export * from "./alertTracker.vue?vue&type=script&lang=js&"
import style0 from "./alertTracker.vue?vue&type=style&index=0&id=654184fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654184fd",
  null
  
)

export default component.exports